import config from "../../common/config";

const SBGlookup = [
  {
    SBGID: "AER",
    SBGName: "Aerospace",
  },
  {
    SBGID: "CORP",
    SBGName: "CORP",
  },
  {
    SBGID: "BA",
    SBGName: "Building Automation",
  },
  {
    SBGID: "PMT",
    SBGName: "Performance Materials and Technologies ",
  },
  {
    SBGID: "SPS",
    SBGName: "Safety and Productivity Solutions",
  },
];
const formSite = {
  items: [
    {
      dataField: "id",
      caption: "ID",
      dataType: "number",
      fixed: true,
      allowEditing: false,
      visible: false,
    },
    {
      itemType: "group",
      colCount: 2,
      colSpan: 2,
      items: [
        {
          dataField: "sbgid",
          caption: "SBG",
          lookup: {
            dataSource: SBGlookup,
            displayExpr: "SBGName",
            valueExpr: "SBGID",
          },
          allowEditing: false,
          //colSpan: 2,
          //editorOptions: {
          //    height: 100
          //}
        },

        {
          dataField: "siteID",
          editorType: "dxTextArea",
          allowEditing: false,
          //colSpan: 2,
          //editorOptions: {
          //    layout: "horizontal"
          //}
        },
        {
          dataField: "siteLatitude",
          caption: "Latitude",
          dataType: "number",
          // format: "#,##0",
          validationRules: [
            {
              type: "required",
              message: "SiteLatitude is required",
            },
          ],
        },
        {
          dataField: "siteName",
          editorType: "dxTextArea",
          allowEditing: false,
          //colSpan: 1,
          //editorOptions: {
          //    height: 150
          //}
        },
        {
          dataField: "siteLongitude",
          caption: "Longitude",
          dataType: "number",
          // format: "#,##0",
          validationRules: [
            {
              type: "required",
              message: "SiteLongitude is required",
            },
          ],
        },
        {
          dataField: "siteDescription",
          editorType: "dxTextArea",
          //colSpan: 1,
          editorOptions: {
            height: 100,
          },
        },
        {
          dataField: "siteAddress",
          editorType: "dxTextArea",
          //colSpan: 1,
          editorOptions: {
            height: 100,
          },
        },
        {
          dataField: "tempUnit",
          editorType: "dxTextArea",
          //colSpan: 1,
          editorOptions: {
            height: 100,
          },
        },
      ],
    },
  ],
};
export const CONFIG = {
  ISAUTOMATEDLINE: [
    {
      text: "Automated line",
      value: true,
    },
    {
      text: "Manual line",
      value: false,
    },
  ],
  SITE_GRID: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },

    export: {
      enabled: true,
      fileName: "Sites",
    },
    //editing: {
    //    mode: 'batch',
    //    allowUpdating: true,
    //    allowAdding: true,
    //    allowDeleting: true,
    //    useIcons: true
    //},
    editing: {
      mode: "popup",
      allowUpdating: config.DEV_DISPLAY_OPTIONS ? true : false,
      allowAdding: false,
      allowDeleting: false,
      useIcons: true,
      popup: {
        title: "Manage Site",
        showTitle: true,
        position: {
          my: "center",
          at: "center",
          of: window,
        },
      },
      //form: formSite
    },
    //onRowPrepared: function (e) {
    //    if (e.rowType == 'data' && e.data.Role == 'Owner') {
    //        e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
    //    }
    //    else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
    //        e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
    //    }
    //    else {
    //        return false;
    //    }
    //aswdf
    //},
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Site" /*function () {
                      return $("<div/>")
                          .append(
                              $("<h5 />")
                                  .addClass("gridLabel")
                                  .text("Manage Site")
                          );
                  }*/,
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  SITE_COL: [
    {
      dataField: "id",
      caption: "ID",
      dataType: "number",
      fixed: true,
      allowEditing: false,
    },
    {
      dataField: "sbgid",
      caption: "SBG",
      //lookup: { dataSource: SBGlookup, displayExpr: "SBGName", valueExpr: "SBGID" },
      validationRules: [
        {
          type: "required",
          message: "SBG is required",
        },
      ],
      allowEditing: false,
    },
    {
      dataField: "siteID",
      caption: "Site",
      validationRules: [
        {
          type: "required",
          message: "Site is required",
        },
      ],
      allowEditing: false,
    },
    {
      dataField: "siteName",
      caption: "Site Name",
      validationRules: [
        {
          type: "required",
          message: "SiteName is required",
        },
      ],
      allowEditing: false,
    },
    {
      dataField: "siteDescription",
      caption: "Site Description",
    },
    {
      dataField: "siteAddress",
      caption: "Site Address",
    },
    {
      dataField: "nextTierName",
      caption: "Parent Id",
    },
    {
      dataField: "siteLatitude",
      caption: "Latitude",
      dataType: "number",
      // format: "#,##0",
      validationRules: [
        {
          type: "required",
          message: "SiteLatitude is required",
        },
      ],
    },
    {
      dataField: "siteLongitude",
      caption: "Longitude",
      dataType: "number",
      // format: "#,##0",
      validationRules: [
        {
          type: "required",
          message: "SiteLongitude is required",
        },
      ],
    },
    {
      dataField: "siteImage",
      caption: "Site Image",
      allowEditing: false,
      editorOption: { allowEditing: false },

      visible: false,
    },
    {
      dataField: "tempUnit",
      caption: "Temp. Unit",
    },
    {
      dataField: "upcomingEvent",
      caption: "Upcoming Event",
    },
  ],
  PEOPLE_GRID: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    /*  paging: {
              pageSize: 10
          },
          pager: {
              showPageSizeSelector: true,
              allowedPageSizes: [5, 10, 20, 50],
              showInfo: true
          },
          */
    export: {
      enabled: true,
      fileName: "People",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
    /*onRowPrepared: function (e) {
            if (e.rowType == 'data' && e.data.Role == 'Owner') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
            }
            else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
            }
            else {
                return false;
            }
        },
        */
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage People",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  Scheduled_report: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },

    export: {
      enabled: true,
      fileName: "ScheduledReport",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
  },
  PEOPLE_COL: [
    {
      dataField: "id",
      caption: "ID",
      visible: false,
      dataType: "number",
      //fixed: true,
      allowEditing: false,
    },

    {
      dataField: "TierId",
      caption: "TierID",
      visible: true,
      // dataType: "number",
      //fixed: true,
      allowEditing: false,
    },
    {
      dataField: "employeeID",
      caption: "EID",
      validationRules: [
        {
          type: "required",
          message: "Employee ID is required",
        },
      ],
    },
    {
      dataField: "employeeName",
      caption: "Employee Name",
      validationRules: [
        {
          type: "required",
          message: "Employee Name is required",
        },
      ],
    },
    {
      dataField: "email",
      caption: "Email",
      validationRules: [
        {
          type: "required",
          message: "Email is required",
        },
        {
          type: "email",
          message: "Email is invalid",
        },
      ],
    },
    {
      dataField: "role",
      caption: "Role",
      lookup: { dataSource: ["Owner", "Alternate", "Member", "Viewer"] },
      validationRules: [
        {
          type: "required",
          message: "Role is required",
        },
      ],
    },
    {
      dataField: "isGembaNew",
      caption: "IsGemba",
    },
  ],
  REASON_CODE_GRID: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    // paging: {
    //   pageSize: 5,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },
    // export: {
    //   enabled: true,
    //   fileName: "Actions",
    // },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
    /*
        onRowPrepared: function (e) {
            if (e.rowType == 'data' && e.data.Role == 'Owner') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
            }
            else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
            }
            else {
                return false;
            }
        },
        */
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Reasoncodes",
        },
      );
    },
  },

  REASON_CODE_GRID_ADMINCONSOLE: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    // paging: {
    //   pageSize: 5,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },
    export: {
      enabled: true,
      fileName: "Actions",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
    /*
        onRowPrepared: function (e) {
            if (e.rowType == 'data' && e.data.Role == 'Owner') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
            }
            else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
            }
            else {
                return false;
            }
        },
        */
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Reasoncodes",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },

  REASON_CODE_COL: [
    {
      dataField: "id",
      caption: "ID",
      dataType: "number",
      width: 50,
      visible: false,
      allowEditing: false,
    },
    {
      dataField: "tierId",
      caption: "Tier ID",
      lookup: {
        dataSource: [],
        valueExpr: "tierID",
        displayExpr: "tierID",
      },

      validationRules: [
        {
          type: "required",
          message: "Tier ID is required",
        },
      ],
    },
    {
      dataField: "tierName",
      caption: "Tier Name",
      lookup: {
        dataSource: [],
        valueExpr: "tierName",
        displayExpr: "tierName",
      },
      // validationRules: [{
      //     type: "required"
      // }],
    },
    {
      dataField: "tierLevel",
      caption: "Tier Level",
      width: 200,
      lookup: {
        dataSource: [],
        valueExpr: "tierLevel",
        displayExpr: "tierLevel",
      },
      // validationRules: [{
      //     type: "required"
      // }],
    },
    {
      dataField: "reasonCode",
      caption: "Reason Codes",
      validationRules: [
        {
          type: "required",
          message: "Reason Code is required",
        },
      ],
    },
  ],

  SMESS_REASON_CODE_GRID_ADMINCONSOLE: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    // paging: {
    //   pageSize: 5,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },
    export: {
      enabled: true,
      fileName: "Actions",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Reasoncodes",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },

  LANGUAGE: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    // paging: {
    //   pageSize: 5,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },
    export: {
      enabled: true,
      fileName: "Language",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,

      useIcons: true,
    },
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Language",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },

  SMESS_REASON_CODE_COL: [
    {
      dataField: "assessmentID",
      caption: "ID",
      dataType: "number",
      width: 50,
      visible: false,
      allowEditing: false,
    },
    {
      dataField: "reasonID",
      caption: "Reason ID",
      dataType: "number",
      width: 50,
      visible: false,
      allowEditing: false,
    },
    {
      dataField: "assessment",
      caption: "Assessment",
      lookup: {
        dataSource: [],
        valueExpr: "assessment",
        displayExpr: "assessment",
      },

      validationRules: [
        {
          type: "required",
          message: "Assessment is required",
        },
      ],
    },
    {
      dataField: "reason",
      caption: "Reason",
      lookup: {
        dataSource: [],
        valueExpr: "reason",
        displayExpr: "reason",
      },
      validationRules: [
        {
          type: "required",
          message: "Reason is required",
        },
      ],
    },
  ],
  VIZUALIZATION_GRID: {
    noDataText: "No Vizualization",
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    paging: {
      pageSize: 10,
    },
    pager: {
      showPageSizeSelector: true,
      allowedPageSizes: [5, 10, 20, 50],
      showInfo: true,
    },
    export: {
      enabled: true,
      fileName: "Viz",
    },
    editing: {
      mode: "popup",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
      popup: {
        title: "Action",
        showTitle: true,
        position: {
          my: "center",
          at: "center",
          of: window,
        },
      },
      form: {
        colCount: 1,
        items: [
          "vizID",
          "vizName",
          {
            dataField: "tierID",
            caption: "Tier",
            lookup: {
              dataSource: [], //tiers,
              valueExpr: "Value",
              displayExpr: "Value",
            },
            width: 150,
            validationRules: [
              {
                type: "required",
                message: "TierID is required",
              },
            ],
          },
          "sqdcp",
          {
            dataField: "order",
            editorType: "Order",
            editorType: "dxNumberBox",
            editorOptions: {
              min: 0,
              max: 10,
              showSpinButtons: true,
            },
          },
          {
            dataField: "code",
            editorType: "dxTextArea",
            editorOptions: {
              height: 200,
            },
          },
        ],
      },
    },
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Vizualization",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  VIZUALIZATION_COL: [
    {
      dataField: "vizID",
      caption: "Viz ID",
      dataType: "number",
      fixed: true,
      width: 100,
      allowEditing: false,
    },
    {
      dataField: "vizName",
      caption: "Viz Name",
      width: 150,
      validationRules: [
        {
          type: "required",
          message: "Name is required",
        },
      ],
    },
    {
      dataField: "tierID",
      caption: "Tier",
      lookup: {
        dataSource: [],
        valueExpr: "tierID",
        displayExpr: "tierID",
      },
      width: 150,
      validationRules: [
        {
          type: "required",
          message: "TierID is required",
        },
      ],
    },
    {
      dataField: "sqdcp",
      caption: "SQDCP",
      width: 150,
      lookup: {
        dataSource: [
          "Performance",
          "Safety",
          "Quality",
          "Delivery",
          "Inventory",
          "Cost",
          "People",
        ],
      },
      validationRules: [
        {
          type: "required",
          message: "SQDCP is required",
        },
      ],
    },
    {
      dataField: "order",
      caption: "Order",
      dataType: "number",
      width: 100,
      validationRules: [
        {
          type: "required",
          message: "Order is required",
        },
      ],
    },
    {
      dataField: "code",
      caption: "Code",
      validationRules: [
        {
          type: "required",
          message: "Code is required",
        },
      ],
    },
  ],
  TIERS_GRID: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },
    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    // paging: {
    //   pageSize: 10,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },
    export: {
      enabled: true,
      fileName: "Tiers_Export",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },

    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Tier",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  TIERS_COL: [
    {
      dataField: "tierID",
      caption: "Tier ID",
      // visible: false,
      dataType: "number",
      width: 200,
      /* validationRules: [{
                 type: "required"
             }],*/
      allowEditing: false,
    },
    {
      dataField: "tierName",
      caption: "Tier Name",

      validationRules: [
        {
          type: "required",
        },
      ],
    },
    {
      dataField: "tierLevel",
      caption: "Tier Level",
      width: 200,
      validationRules: [
        {
          type: "required",
        },
      ],
    },

    {
      dataField: "duration",
      caption: "Digital Tier Duration(Mins.)",
      dataType: "number",
      maxLength: 2,
      width: 250,
      validationRules: [
        {
          type: "required",
          message: "Duration is required",
        },
        {
          type: "range",
          max: 60,
          message: "Minutes must be less than 60",
        },
      ],
    },
  ],
  noOfEvents: ["Top 3", "Top 5", "Top 10", "3 Days", "5 Days", "10 Days"],
  Incident_GRID: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },
    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    // paging: {
    //   pageSize: 10,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },
    export: {
      enabled: true,
      fileName: "Actions",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },

    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Incident",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  INCIDENT_COL: [
    {
      dataField: "id",
      caption: "ID",
      dataType: "number",
      width: 50,
      visible: false,
      allowEditing: false,
      showInColumnChooser: false,
    },
    {
      dataField: "tierID",
      caption: "Tier ID",
      lookup: {
        dataSource: [],
        valueExpr: "tierID",
        displayExpr: "tierID",
      },

      validationRules: [
        {
          type: "required",
          message: "Tier ID is required",
        },
      ],
    },
    {
      dataField: "tierName",
      caption: "Tier Name",

      validationRules: [
        {
          type: "required",
        },
      ],
    },
    {
      dataField: "tierLevel",
      caption: "Tier Level",
      width: 200,
      validationRules: [
        {
          type: "required",
        },
      ],
    },
    {
      dataField: "incidentType",
      caption: "Incident Type",
      validationRules: [
        {
          type: "required",
          message: "Incident Type is required",
        },
      ],
    },
  ],
  GEMBA_TYPES: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    // paging: {
    //   pageSize: 5,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },
    export: {
      enabled: true,
      fileName: "GEMBA Types",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },

    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Gemba Types",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  GEMBA_TYPE_COL: [
    {
      dataField: "id",
      caption: "ID",
      dataType: "string",
      width: 50,
      visible: false,
      allowEditing: false,
      showInColumnChooser: false,
    },
    {
      dataField: "gembaType",
      caption: "Gemba Type",
      validationRules: [
        {
          type: "required",
          message: "Gemba Type",
        },
      ],
    },
  ],
  CALENDAR_EVENT_TYPES: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    // paging: {
    //   pageSize: 5,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },
    export: {
      enabled: true,
      fileName: "Calendar Event Types",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },

    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Calendar Event Types",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  PINNED_MAIL_GRID: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    loadPanel: {
      enabled: true,
      showIndicator: true,
      showPane: true,
    },
    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },

    editing: {
      mode: "batch",
      allowUpdating: true,

      allowDeleting: true,
      useIcons: true,
    },
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
    },
  },

  MAIL_GRID: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },

    loadPanel: {
      enabled: true,
      showIndicator: true,
      showPane: true,
    },

    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: false,
      allowDeleting: false,
      useIcons: true,
    },
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "Manage Mail",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  CALENDAR_EVENT_TYPE_COL: [
    {
      dataField: "id",
      caption: "ID",
      dataType: "number",
      width: 50,
      visible: false,
      allowEditing: false,
    },
    {
      dataField: "calendarEventType",
      caption: "Event Type",
      validationRules: [
        {
          type: "required",
          message: "Event Type",
        },
      ],
    },
  ],
  LOOKUPTIERLEVELDATASOURCECONFIG: {
    store: {
      type: "array",
      data: [
        { id: 1, tierLevel: 1 },
        { id: 2, tierLevel: 2 },
        { id: 3, tierLevel: 3 },
        { id: 4, tierLevel: 4 },
      ],
      key: "name",
    },
  },
  LOOKUPTIERNAMEDATASOURCECONFIG: {
    store: {
      type: "array",
      data: [
        { id: 1, tiername: "test t1" },
        { id: 2, tiername: "Tier1_Dept1" },
        { id: 3, tiername: "Charleston Test T4" },
      ],
      key: "name",
    },
  },
  LOOKUPROLEDATASOURCECONFIG: {
    store: {
      type: "array",
      data: [
        { id: 1, name: "Owner" },
        { id: 2, name: "Alternate" },
        { id: 3, name: "Member" },
        { id: 4, name: "Viewer" },
      ],
      key: "name",
    },
  },
  ISGEMBACONFIG: [
    {
      text: "Checked",
      value: true,
    },
    {
      text: "UnChecked",
      value: false,
    },
  ],
  LOOKUPDURATIONCONFIG: {
    store: {
      type: "array",
      data: [
        { id: 3, name: "3 Days" },
        { id: 5, name: "5 Days" },
        { id: 10, name: "10 Days" },
        { id: 0, name: "Indefinite" },
      ],
      key: "name",
    },
  },
  //noOfDuration: ['3 Days', '5 Days', '10 Days', 'Indefinite'],

  OPH_MISS_REASON_CODES_GRID: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    paging: {
      pageSize: 5,
    },
    pager: {
      showPageSizeSelector: true,
      allowedPageSizes: [5, 10, 20, 50],
      showInfo: true,
    },
    export: {
      enabled: true,
      fileName: "Actions",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
    /*
        onRowPrepared: function (e) {
            if (e.rowType == 'data' && e.data.Role == 'Owner') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
            }
            else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
            }
            else {
                return false;
            }
        },
        */
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "OPH Miss Reason Codes",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  OPH_MISS_REASON_CODES_COL: [
    {
      dataField: "id",
      caption: "ID",
      dataType: "number",
      width: 50,
      visible: false,
      allowEditing: false,
    },
    {
      dataField: "tierId",
      caption: "Tier ID",
      lookup: {
        dataSource: [],
        valueExpr: "tierID",
        displayExpr: "tierID",
      },

      validationRules: [
        {
          type: "required",
          message: "Tier ID is required",
        },
      ],
    },
    {
      dataField: "reasonCode",
      caption: "Reason Codes",
      validationRules: [
        {
          type: "required",
          message: "Reason Code is required",
        },
      ],
    },
    {
      dataField: "description",
      caption: "Description",
      validationRules: [
        {
          type: "required",
          message: "Description is required",
        },
      ],
    },
  ],
  HSE: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },
    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    scrolling: { showScrollbar: "always" },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },

    export: {
      enabled: true,
      fileName: "HSE Tasks",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      toolbarItems.unshift(
        {
          location: "before",
          template: "HSE Communication Tasks",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
  HSE_COL: [
    {
      dataField: "id",
      caption: "ID",
      dataType: "string",
      width: 50,
      visible: false,
      allowEditing: false,
      showInColumnChooser: false,
    },
    {
      dataField: "task",
      caption: "HSE Communication Task",
      validationRules: [
        {
          type: "required",
          message: "HSE Communication Task",
        },
      ],
    },
  ],

  LOOKUPTIERLEVELDATASOURCECONFIGFORADMINCONSOLE: {
    store: {
      type: "array",
      data: [
        { id: 1, tierLevel: 1 },
        { id: 2, tierLevel: 2 },
        { id: 3, tierLevel: 3 },
        { id: 4, tierLevel: 4 },
        { id: 5, tierLevel: 5 },
        { id: 6, tierLevel: 6 },
        { id: 7, tierLevel: 7 },
        { id: 8, tierLevel: 8 },
      ],
      key: "name",
    },
  },

  LOOKUPCATEGORYCONFIG: {
    store: {
      type: "array",
      data: [
        { id: 1, name: "Safety" },
        { id: 2, name: "5S" },
      ],
      key: "name",
    },
  },

  LOOKUPFREQUENCYCONFIG: {
    store: {
      type: "array",
      data: [{ id: 1, name: "Daily" }],
      key: "name",
    },
  },
};
